import bg from "../images/college_fest/college_fest_background.png";
import logo from "../images/college_fest/college_fest_logo.png";
import stageImg from "../images/college_fest/stageImg.png";      // 🔥 add stage image
import djImg from "../images/college_fest/djImage.png";            // 🔥 add DJ image

export const slides = [

/* ---------------- 🎬 SLIDE 1 — GRAND INTRO ---------------- */
[
  {
    id: 1,
    type: "background",
    src: bg,
    x: 0,
    y: 0,
    width: 595,
    height: 842
  },

  {
    id: 2,
    type: "text",
    text: "✨ PRESENTING ✨",
    x: 180,
    y: 70,
    fontSize: 24,
    fontFamily: "Montserrat",
    fill: "#f5b215"
  },

  {
    id: 3,
    type: "text",
    text: "ANNUAL COLLEGE FEST 2026",
    x: 60,
    y: 140,
    fontSize: 34,
    fontFamily: "Poppins",
    fill: "#f5b215"
  },

  {
    id: 4,
    type: "text",
    text: "Where Talent Meets Celebration 🎭",
    x: 90,
    y: 210,
    fontSize: 20,
    fontFamily: "Poppins",
    fill: "#f5b215"
  },

  {
    id: 5,
    type: "image",
    src: stageImg,
    x: 20,
    y: 300,
    width: 550,
    height: 450
  }
],

/* ---------------- 🎬 SLIDE 2 — EVENTS & HIGHLIGHTS ---------------- */
[
  {
    id: 6,
    type: "background",
    src: bg,
    x: 0,
    y: 0,
    width: 595,
    height: 842
  },
   {
    id: 12,
    type: "image",
    src: logo,
    x: 0,
    y: 0,
    width: 600,
    height: 850
  },

  {
    id: 7,
    type: "text",
    text: "🔥EXPERIENCE THE FEST🔥",
    x: 130,
    y: 90,
    fontSize: 28,
    fontFamily: "Open Sans",
    fill: "#e11d48"
  },

  
{
  id: 22,
  type: "text",
  text: "💻 Hackathon • Coding Contest",
  x: 120,
  y: 230,
  fontSize: 20,
  fontFamily: "Poppins",
  fill: "#111827"
},

{
  id: 23,
  type: "text",
  text: "🧠 Quiz • Debate • Elocution",
  x: 120,
  y: 280,
  fontSize: 20,
  fontFamily: "Poppins",
  fill: "#111827"
},

{
  id: 24,
  type: "text",
  text: "🔬 Science Expo • Project Display",
  x: 120,
  y: 330,
  fontSize: 20,
  fontFamily: "Poppins",
  fill: "#111827"
},

{
  id: 25,
  type: "text",
  text: "📊 Business Pitch • Startup Ideas",
  x: 120,
  y: 380,
  fontSize: 20,
  fontFamily: "Poppins",
  fill: "#111827"
},

{
  id: 26,
  type: "text",
  text: "🎤 Live DJ Night & Performances",
  x: 120,
  y: 430,
  fontSize: 20,
  fontFamily: "Poppins",
  fill: "#111827"
},


  {
    id: 8,
    type: "text",
    text: "🎭 Dance • Music • Drama",
    x: 120,
    y: 480,
    fontSize: 20,
    fontFamily: "Poppins",
    fill: "#111827"
  },

  {
    id: 9,
    type: "text",
    text: "🎮 Gaming • Tech Events",
    x: 120,
    y: 530,
    fontSize: 20,
    fontFamily: "Poppins",
    fill: "#111827"
  },

  {
    id: 10,
    type: "text",
    text: "🎤 Live DJ Night & Performances",
    x: 120,
    y: 580,
    fontSize: 20,
    fontFamily: "Poppins",
    fill: "#111827"
  },

  {
    id: 11,
    type: "text",
    text: "🎁 Exciting Prizes & Non-stop Fun",
    x: 120,
    y: 630,
    fontSize: 20,
    fontFamily: "Poppins",
    fill: "#f5b215"
  },
],

/* ---------------- 🎬 SLIDE 3 — DETAILS & INVITE ---------------- */
[
  {
    id: 14,
    type: "background",
    src: bg,
    x: 0,
    y: 0,
    width: 595,
    height: 842
  },

  {
    id: 15,
    type: "text",
    text: "📅 20 March 2026",
    x: 150,
    y: 180,
    fontSize: 22,
    fontFamily: "Poppins",
    fill: "#111827"
  },

  {
    id: 16,
    type: "text",
    text: "⏰ 10:00 AM onwards",
    x: 150,
    y: 230,
    fontSize: 22,
    fontFamily: "Poppins",
    fill: "#111827"
  },

  {
    id: 17,
    type: "text",
    text: "📍 College Grounds",
    x: 160,
    y: 280,
    fontSize: 22,
    fontFamily: "Poppins",
    fill: "#111827"
  },

  {
    id: 18,
    type: "text",
    text: "🎉 Don't Miss The Celebration 🎉",
    x: 90,
    y: 360,
    fontSize: 26,
    fontFamily: "Open Sans",
    fill: "#f5b215"
  },

  {
    id: 19,
    type: "text",
    text: "Join us & create unforgettable memories!",
    x: 60,
    y: 420,
    fontSize: 20,
    fontFamily: "Poppins",
    fill: "#374151"
  },

  {
    id: 20,
    type: "text",
    text: "❤️ See You There ❤️",
    x: 170,
    y: 480,
    fontSize: 26,
    fontFamily: "Dancing Script",
    fill: "#000"
  },

  {
    id: 21,
    type: "image",
    src: djImg,
    x: 100,
    y: 550,
    width: 400,
    height: 250
  }
]

];